module.exports = __webpack_public_path__ + "images/hikakaku-nokotta_f0a979aee8ad0076072ff038c13f3c96.png";